<template>
    <div>
        <div class="agreement-container">
            Users are advised to read the
            <a
                href="https://www.bohemia.net/privacy-policy"
                rel="noopener noreferrer"
                target="_blank"
                >User Agreement & Privacy Policy.</a
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'SidebarUserAgreement',
};
</script>

<style scoped lang="scss">
.agreement-container {
    width: 345px;
    height: 78px;
    padding-left: 40px;
    color: $blue-main;
    font-family: $palanquin-font;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.29px;
    line-height: 24px;
    a {
        text-decoration: underline;
    }
    @media (max-width: $xl-up) {
        width: 90%;
    }
    @media (max-width: $lg-up) {
        /* Style for "Users are" */
        width: 100%;
        height: 46px;
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0.22px;
        line-height: 18px;
        padding-top: 5%;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        width: 290px;
        height: 46px;
        font-size: 14px;
        letter-spacing: 0.22px;
        line-height: 18px;
    }
}
</style>
